import {
  type AtomicBulkUpdateRequest,
  type AtomicBulkUpdateResponse,
  atomicBulkUpdateShows,
} from "@punchup/data/client/manager/shows";

import { useMutation } from "@tanstack/react-query";

interface UseAtomicBulkUpdateShowsReturn {
  mutateAsync: (
    data: AtomicBulkUpdateRequest
  ) => Promise<AtomicBulkUpdateResponse>;
  isPending: boolean;
}

/**
 * Atomically bulk-updates shows across Tixologi and Punchup in a single
 * server-side call. Uses a compensating-transaction (Saga) pattern: if the
 * Punchup DB write fails after Tixologi succeeds, the server automatically
 * rolls Tixologi back to the client-provided snapshot state.
 */
export function useAtomicBulkUpdateShows(): UseAtomicBulkUpdateShowsReturn {
  const mutation = useMutation({
    mutationFn: (data: AtomicBulkUpdateRequest) => atomicBulkUpdateShows(data),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
}
